/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './../routes/__root'
import { Route as IndexRouteImport } from './../routes/index'
import { Route as AccessRouteImport } from './../routes/access'
import { Route as OrganizationsRouteImport } from './../routes/organizations'
import { Route as SpecializationCatalogsRouteImport } from './../routes/specialization-catalogs'
import { Route as OrganizationsOrganizationIdRouteImport } from './../routes/organizations_.$organizationId'
import { Route as SpecializationCatalogsCatalogIdRouteImport } from './../routes/specialization-catalogs_.$catalogId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AccessRoute = AccessRouteImport.update({
  id: '/access',
  path: '/access',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationsRoute = OrganizationsRouteImport.update({
  id: '/organizations',
  path: '/organizations',
  getParentRoute: () => rootRouteImport,
} as any)
const SpecializationCatalogsRoute = SpecializationCatalogsRouteImport.update({
  id: '/specialization-catalogs',
  path: '/specialization-catalogs',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationsOrganizationIdRoute =
  OrganizationsOrganizationIdRouteImport.update({
    id: '/organizations_/$organizationId',
    path: '/organizations/$organizationId',
    getParentRoute: () => rootRouteImport,
  } as any)
const SpecializationCatalogsCatalogIdRoute =
  SpecializationCatalogsCatalogIdRouteImport.update({
    id: '/specialization-catalogs_/$catalogId',
    path: '/specialization-catalogs/$catalogId',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/access': typeof AccessRoute
  '/organizations': typeof OrganizationsRoute
  '/specialization-catalogs': typeof SpecializationCatalogsRoute
  '/organizations/$organizationId': typeof OrganizationsOrganizationIdRoute
  '/specialization-catalogs/$catalogId': typeof SpecializationCatalogsCatalogIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/access': typeof AccessRoute
  '/organizations': typeof OrganizationsRoute
  '/specialization-catalogs': typeof SpecializationCatalogsRoute
  '/organizations/$organizationId': typeof OrganizationsOrganizationIdRoute
  '/specialization-catalogs/$catalogId': typeof SpecializationCatalogsCatalogIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/access': typeof AccessRoute
  '/organizations': typeof OrganizationsRoute
  '/specialization-catalogs': typeof SpecializationCatalogsRoute
  '/organizations_/$organizationId': typeof OrganizationsOrganizationIdRoute
  '/specialization-catalogs_/$catalogId': typeof SpecializationCatalogsCatalogIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/access'
    | '/organizations'
    | '/specialization-catalogs'
    | '/organizations/$organizationId'
    | '/specialization-catalogs/$catalogId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/access'
    | '/organizations'
    | '/specialization-catalogs'
    | '/organizations/$organizationId'
    | '/specialization-catalogs/$catalogId'
  id:
    | '__root__'
    | '/'
    | '/access'
    | '/organizations'
    | '/specialization-catalogs'
    | '/organizations_/$organizationId'
    | '/specialization-catalogs_/$catalogId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccessRoute: typeof AccessRoute
  OrganizationsRoute: typeof OrganizationsRoute
  SpecializationCatalogsRoute: typeof SpecializationCatalogsRoute
  OrganizationsOrganizationIdRoute: typeof OrganizationsOrganizationIdRoute
  SpecializationCatalogsCatalogIdRoute: typeof SpecializationCatalogsCatalogIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/access': {
      id: '/access'
      path: '/access'
      fullPath: '/access'
      preLoaderRoute: typeof AccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organizations': {
      id: '/organizations'
      path: '/organizations'
      fullPath: '/organizations'
      preLoaderRoute: typeof OrganizationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/specialization-catalogs': {
      id: '/specialization-catalogs'
      path: '/specialization-catalogs'
      fullPath: '/specialization-catalogs'
      preLoaderRoute: typeof SpecializationCatalogsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organizations_/$organizationId': {
      id: '/organizations_/$organizationId'
      path: '/organizations/$organizationId'
      fullPath: '/organizations/$organizationId'
      preLoaderRoute: typeof OrganizationsOrganizationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/specialization-catalogs_/$catalogId': {
      id: '/specialization-catalogs_/$catalogId'
      path: '/specialization-catalogs/$catalogId'
      fullPath: '/specialization-catalogs/$catalogId'
      preLoaderRoute: typeof SpecializationCatalogsCatalogIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccessRoute: AccessRoute,
  OrganizationsRoute: OrganizationsRoute,
  SpecializationCatalogsRoute: SpecializationCatalogsRoute,
  OrganizationsOrganizationIdRoute: OrganizationsOrganizationIdRoute,
  SpecializationCatalogsCatalogIdRoute: SpecializationCatalogsCatalogIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
